import { render } from "./CheckboxCell.vue?vue&type=template&id=4390687a"
import script from "./CheckboxCell.vue?vue&type=script&lang=js"
export * from "./CheckboxCell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__